import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { articleSlugs } from "@/data/articles";
import { articleContent } from "@/pages/article/content";

export default function ArticleGrid() {
  const { t, i18n } = useTranslation();
  const lang = (i18n.language || "en").split("-")[0];
  const list = articleContent[lang] || articleContent.en;

  return (
    <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
      {articleSlugs.map((slug) => {
        const article = list[slug];
        if (!article) return null;
        return (
          <Link
            key={slug}
            to={`/article/${slug}`}
            className="group flex flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition hover:-translate-y-0.5 cursor-pointer"
          >
            <div className="relative h-40 w-full overflow-hidden">
              <img
                src={article.image}
                alt={article.title}
                title={`${article.title} - Basetao Spreadsheet`}
                className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
              />
            </div>
            <div className="flex flex-1 flex-col p-5">
              <span className="inline-flex w-fit items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-900">
                <i className="ri-book-open-line"></i>
                {article.eyebrow}
              </span>
              <h3 className="mt-3 font-heading text-base font-bold leading-snug text-foreground-950 md:text-lg">
                {article.title}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{article.cardDescription}</p>
              <span className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-primary-700 transition group-hover:text-primary-800">
                {t("guides.readArticle")}
                <i className="ri-arrow-right-line"></i>
              </span>
            </div>
          </Link>
        );
      })}
    </div>
  );
}